import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/services/auth-guard.service';
import { GlobalPortalGuard } from '../core/services/global-guard.service';
import { MessagingPageComponent } from './containers/messaging-page.component';
import { MessagingWrapperComponent } from './containers/messaging-wrapper.component';
import { LegacyMessagingModule } from './legacy/legacy-messaging.module';

export const COMPONENTS = [MessagingPageComponent, MessagingWrapperComponent];

@NgModule({
  imports: [
    CommonModule,
    LegacyMessagingModule, // Import legacy components for conditional rendering
    RouterModule.forChild([
      {
        path: 'messages',
        canActivate: [AuthGuard, GlobalPortalGuard],
        children: [
          { path: '', component: MessagingWrapperComponent },
          { path: ':conversationId', component: MessagingWrapperComponent }
        ]
      }
    ])
  ],
  declarations: COMPONENTS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MessagingModule {
  // V3 module is simplified - legacy module handles store initialization
}
